import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import Popup from "@my-dld/components/Popup/Popup";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { LocaleUtil } from "@eres/core";
import { JQModal } from "@my-dld/components/Popup/Utils";

interface Props {
	applicationRef?: string;
	property: AssetCard;
	isCancel: boolean;
	onDismiss: () => void;
}

interface State {
}

class SuccessPopup extends Component<Props, State> {
	render() {
		const { applicationRef, isCancel } = this.props;
		let message = Strings.sell_request_success;
		if ( isCancel ) message = Strings.req_cancelled_sucess;
		return <Popup
			id={ "SellerSuccessPopup" }
			modalMainContainer={ "modal fade" }
			clickOutsideToDismiss={ false }
			showCloseButton={ true }
			closeClass={ "close modal-close-svg-icon" }
			closeSpanClass={ "close-svg-icon" }
			modalBodyContainer={ "modal-body" }
			showIcon={ false }
			title={ Strings.confirmation }
			onDismiss={ this.dismissModel }>
			<div className="d-flex flex-column">
				<div className="check-icon">
					<i className="fa fa-check"/>
				</div>
				<p className="text-center">{ message }</p>
				<div className="refn-box">
					{ Strings.booking_ref_number }: <span>{ applicationRef }</span>
				</div>
				<div className="col-12 text-center mb-3">
					{ applicationRef && <a
						href={ this.getShareData() }
						className="underline me-2">{ Strings.share }</a> }
					<button
						type="button" className="btn btn_1 btn-sm btn_style1"
						onClick={ this.copy }>{ Strings.copy }
					</button>
				</div>
			</div>
			<div className="modal-footer d-flex justify-content-center hide">
				<button type="button" className="btn btn_1" onClick={ this.dismissModel }>{ Strings.home }</button>
			</div>
		</Popup>;
	}

	private dismissModel = () => {
		JQModal( "SellerSuccessPopup" ).hide();
		if ( this.props.onDismiss )
			this.props.onDismiss();
	};

	private getShareData() {
		const { applicationRef, property } = this.props;
		let info = `${ LocaleUtil.getLocalValue( property.title ) }\n`;
		info += `${ Strings.booking_ref_number }: ${ applicationRef }\n`;
		return `mailto: ?subject=${ Strings.booking_ref_number }&body=${ encodeURIComponent( info ) }`;
	}

	private copy = () => {
		const { applicationRef } = this.props;
		if ( applicationRef ) navigator.clipboard.writeText( applicationRef ).then().catch();
	};
}

export default SuccessPopup;
